<template>

  <el-dialog
    title="Просмотр данных пуша"
    :visible="visible"
    :before-close="close"
    @opened="onOpen"
  >

    <el-table
      :data="Object.entries(data)"
      style="width: 100%">
      <el-table-column
        prop="date"
        label="Тип"
        width="180">
        <template slot-scope="scope">
          {{ scope.row[0] }}
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        label="Значение">
        <template slot-scope="scope">
          <code>{{ scope.row[1] }}</code>
        </template>
      </el-table-column>
    </el-table>

    <span slot="footer" class="dialog-footer">
        <el-button
          name="save"
          type="primary"
          @click="close()"
        >Закрыть</el-button>
      </span>

  </el-dialog>
</template>

<script>
import Vue from 'vue'
import VueMask from 'v-mask'

Vue.use(VueMask)

export default {
  name: 'DialogWorkerEdit',
  data () {
    return {}
  },
  mounted () {

  },
  props: {
    data: {
      required: true
    },
    visible: {
      required: true
    }
  },
  computed: {},
  methods: {
    onOpen () {
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">

.dialog {
  &__btns {
    float: right;
  }
}

</style>
